<template>
  <div key="transition-child" class="mission-address-component">
    <Field
      v-slot="{ errors, field, value }"
      v-model="_street"
      :name="$filters.formLabelValidation($t('ETAB.FORMS.LABELS.@MISSION_ADDRESS'))"
      :rules="{ required: true }"
    >
      <QInput
        v-bind="field"
        :model-value="value"
        :label="$t('ETAB.FORMS.LABELS.@MISSION_ADDRESS')"
        :name="iModel.street"
        filled
        type="text"
        :error="errors.length > 0"
        :error-message="errors[0]"
      />
    </Field>

    <div class="row q-col-gutter-md">
      <!-- zipcode -->
      <Field
        v-slot="{ errors, field, value }"
        v-model="_zipcode"
        :name="$filters.formLabelValidation($t('ETAB.FORMS.LABELS.@ETAB_POSTAL_CODE'))"
        :rules="{ required: true }"
      >
        <QInput
          v-bind="field"
          :model-value="value"
          :label="$t('ETAB.FORMS.LABELS.@ETAB_POSTAL_CODE')"
          :name="iModel.zipcode"
          filled
          type="number"
          class="col-6"
          :error="errors.length > 0"
          :error-message="errors[0]"
        />
      </Field>
      <!-- city -->
      <Field
        v-slot="{ errors, field, value }"
        v-model="_city"
        :name="$filters.formLabelValidation($t('ETAB.FORMS.LABELS.@ETAB_CITY'))"
        :rules="{ required: true }"
      >
        <QInput
          v-bind="field"
          :model-value="value"
          :label="$t('ETAB.FORMS.LABELS.@ETAB_CITY')"
          filled
          :name="iModel.city"
          type="text"
          class="col-6"
          :error="errors.length > 0"
          :error-message="errors[0]"
        />
      </Field>
    </div>
  </div>
</template>

<script>
  import { Field } from "vee-validate";

  export default {
    components: { Field },
    props: {
      iModel: { type: Object, default: () => ({}) },
      street: {
        type: String,
        default: "",
      },
      zipcode: {
        type: String,
        default: "",
      },
      city: {
        type: String,
        default: "",
      },
    },
    emits: ["update:city", "update:zipcode", "update:street"],
    computed: {
      _street: {
        get() {
          return this.street;
        },
        set(value) {
          this.$emit("update:street", value);
        },
      },
      _zipcode: {
        get() {
          return this.zipcode;
        },
        set(value) {
          this.$emit("update:zipcode", value);
        },
      },
      _city: {
        get() {
          return this.city;
        },
        set(value) {
          this.$emit("update:city", value);
        },
      },
    },
  };
</script>

<style lang="scss">
  .mission-address-component {
    margin-top: 24px;
    .q-field {
      margin-bottom: 24px;
    }
  }
</style>
